export enum ErrorMessage {
  NAME_EXIST = 'NAME_EXIST',
  DATA_NULL = 'DATA_NULL'
}
